export default __webpack_public_path__ + "static/media/shipped.915a54d0.png";